import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import Routes from "./Routes";
import { Navbar, Nav, NavItem, Image, Grid, Row, Col } from "react-bootstrap";
import "./App.css";
import ReactGA from 'react-ga4';

class App extends Component {
  constructor(props) {
    super(props);
    this.homeRef = React.createRef();
    this.state = {
      expanded: false
    }
  }
  async componentDidMount() {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname});
  }
  onToggle = (event) => {
  	this.setState({ expanded: !this.state.expanded });
  }
  onSelect = (event) => {
    this.setState({ expanded: false });
  }

  renderMenu() {
    return (
      <header className="header">
        <Navbar onToggle={this.onToggle} onSelect={this.onSelect} expanded={this.state.expanded}>
          <Navbar.Header>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to="/" onClick={this.handleScrollTo}>
                  <Image src="/images/logo.png" responsive />
                </Link>
              </Navbar.Brand>
              {/* <a href="http://bit.ly/PizarroVialwsp" target="_blank" className="whatsapp_mobile" rel="noopener noreferrer">
                <i className="fa fa-whatsapp"></i>
              </a> */}
              <Navbar.Toggle />
            </Navbar.Header>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem eventKey={1} href="#root" onClick={this.handleScrollTo}>Inicio</NavItem>
              <NavItem eventKey={2} href="#about" onClick={this.handleScrollTo}>Nosotros</NavItem>
              <NavItem eventKey={3} href="#services" onClick={this.handleScrollTo}>Servicios</NavItem>
              <NavItem eventKey={4} href="#projects" onClick={this.handleScrollTo}>Proyectos</NavItem>
              <NavItem eventKey={5} href="#contact" onClick={this.handleScrollTo}>Contacto</NavItem>
              <NavItem eventKey={6} href="http://bit.ly/PizarroVialwsp" target="_blank" className="whatsapp">
                <i className="fa fa-whatsapp"></i>WhatsApp
              </NavItem>
              {/* <NavItem eventKey={6} href="tel:+56988147296" target="_blank" className="phone">
                <i className="fa fa-phone"></i>Llamar
              </NavItem> */}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    );
  }

  renderFooter() {
    return (
      <footer className="footer">
        <Grid>
          <Row>
            <Col md={3}>
              <div className="media-wrap">
                <a href="/#root" onClick={this.handleScrollTo}>
                  <img src="/images/logo-v.png" alt="PizarroVial Constructora" title="PizarroVial Constructora" />
                </a>
              </div>
            </Col>
            <Col md={3}>
              <h5 className="pb-3">PizarroVial Constructora</h5>
              <p className="mbr-text">Enfrentamos con entusiasmo una nueva etapa de crecimiento y diversificación. Asumimos el desafío de mantener el liderazgo alcanzado y seguir construyendo sobre la base de la responsabilidad, la innovación, la confianza y credibilidad.</p>
            </Col>
            <Col md={3}>
              <h5 className="pb-3">Contacto</h5>
              <p className="mbr-text">
                Email contacto: <a href="mailto:contacto@pizarrovial.cl">contacto@pizarrovial.cl&nbsp;</a><br/>
                Email licitación: <a href="mailto:licitacion@pizarrovial.cl">licitacion@pizarrovial.cl&nbsp;</a><br/>
                Fono: <a href="tel:+56222336059">+56 2 2233 6059 </a><br/>
                Dirección: Av. del Valle #601 OF. 51, Ciudad Empresarial, Huechuraba, Región Metropolitana
              </p>
            </Col>
            <Col md={3}>
              <h5 className="pb-3">Links</h5>
              <p className="mbr-text">
                <a className="text-primary" href="/#about" onClick={this.handleScrollTo}>Nosotros</a><br/>
                <a className="text-primary" href="/#services" onClick={this.handleScrollTo}>Servicios</a><br/>
                <a className="text-primary" href="/#contact" onClick={this.handleScrollTo}>Contacto</a><br/>
                <a className="text-primary" href="mailto:contacto@pizarrovial.cl">Email contacto</a><br/>
                <a className="text-primary" href="mailto:licitacion@pizarrovial.cl">Email licitación</a><br/>
                <a href="http://bit.ly/PizarroVialwsp" target="_blank" rel="noopener noreferrer">Whatsapp</a><br/>
                <a href="tel:+56222336059">Llamar</a>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <hr/>
            </Col>
          </Row>
          <Row className="footer-lower">
            <Col md={6} className="copyright">
              <p className="mbr-text mbr-fonts-style display-7">
                &copy; Copyright 2025 PizarroVial Constructora - Sitio desarrollado por <Navbar.Link href="http://www.neokode.cl" target="_blank">Neokode</Navbar.Link>
              </p>
            </Col>
            <Col md={6}>
              <div className="social-list align-right">
                <div className="soc-item">
                  <a href="https://www.instagram.com/pizarrovial_constructora/" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-instagram"></i>
                  </a>
                </div>
                {/* <div className="soc-item">
                  <a href="https://www.facebook.com/pizarrovial" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-facebook"></i>
                  </a>
                </div> */}
                <div className="soc-item">
                  <a href="https://cl.linkedin.com/company/constructora-pizarrovial" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </footer>
    );
  }

  handleRef = (ref) => {
    this.homeRef = ref;
  }
  handleScrollTo = (evt) => {
    evt.preventDefault();
    const to = evt.currentTarget.hash;
    this.homeRef.scrollTo(to);
  }
  render() {
    const childProps = {
      onRef: this.handleRef
    };
    return (
      <div className="App">
        { this.renderMenu() }
        <Routes childProps={childProps} />
        { this.renderFooter() }
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js